export const getConfig = () => {
  const name = import.meta.env.VITE_ENVIRONMENT || "dev";
  const authTenantId =
    import.meta.env.VITE_AUTH_TENANT_ID ||
    "c5546184-c827-45e1-bdca-78353c329c48";
  const authClientAppId =
    import.meta.env.VITE_AUTH_CLIENT_APPID ||
    "ba4336af-ab71-43de-8886-fa8da0d01f63";
  const authServerAppId =
    import.meta.env.VITE_AUTH_SERVER_APPID ||
    "1e3ea49f-bce2-43ab-8091-ee3363072ca7";

  let backendUrl = "";
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case "prod":
      backendUrl = "https://prod.mps.mpi.app.medi.de";
      break;
    case "stage":
      backendUrl = "https://stage.mps.mpi.app.medi.de";
      break;
    case "dev":
      backendUrl = "https://dev.mps.mpi.app.medi.de";
      break;
    default:
      backendUrl = "https://localhost:6202";
      break;
  }

  return {
    name: name,
    authTenantId: authTenantId,
    authClientAppId: authClientAppId,
    authServerAppId: authServerAppId,
    httpTimeoutMs: 300000,
    backendUrl: backendUrl,
    apiUrl: "mceapi",
  };
};

export const getConfigName = (): "local" | "dev" | "stage" | "prod" => {
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case "prod":
      return "prod";
    case "stage":
      return "stage";
    case "dev":
      return "dev";
    default:
      return "local";
  }
};
